import { Injectable } from '@angular/core';
import {Storage} from './cached-http.service';
import { of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CacheStorageService implements Storage {
  get(key: string): Promise<any> {
    return Promise.resolve(JSON.parse((localStorage.getItem(key))));
  }
  set(key: string, data: any): Promise<any> {
    localStorage.setItem(key, JSON.stringify(data));
    return this.get(key)
  }
  remove(key: string) {
    return localStorage.removeItem(key);
  }

  constructor() { 

  }

}
